/**
 * This file contains constants that are only used by the capture-web and are not to be seen by the other products
 */

export const SENTRY_DSN__FULL_WEB = 'https://c0163e0df39f4aa7af7eb2e0846162fe@sentry.io/266201'
